import { useState, useEffect, useCallback } from 'react';
import { useDroplet } from '../context/DropletContext';
import { useInterval } from './useInterval';

export function useBotActivity(site?: string, days = 30, autoRefresh = true, refreshInterval = 60000) {
  // Bot activity is a single shared dataset across all 3pplea products (one
  // central DB on the home droplet) — never per-droplet, so this always
  // uses authApi regardless of which droplet is currently selected.
  const { authApi } = useDroplet();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const botData = await authApi.getBotActivity(site, days);
      setData(botData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch bot activity');
      console.error('Error fetching bot activity:', err);
    } finally {
      setLoading(false);
    }
  }, [authApi, site, days]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useInterval(
    () => {
      fetchData();
    },
    autoRefresh ? refreshInterval : null
  );

  return {
    summary: data?.summary || [],
    daily: data?.daily || [],
    loading,
    error,
    refresh: fetchData,
  };
}
